<template>
    <div>

        <trax-ui-card-icon-header class="mt-5"
            header-color="info" icon="playlist_add_check" :title="lang.polaris.dashboard.skills_progress"
            :actions="actions" :bus="bus"
        >
            <div v-show="loaded" class="skills-progress-units mb-3">
                <table class="mb-3">
                    <tbody>
                        <!-- Modules -->
                        <tr v-if="titles.length > 3">
                            <th v-for="(col, index) in titles" :key="index" :colspan="col.colspan" :class="col.type">
                                <span> {{ col.title }} </span>
                            </th>
                        </tr>
                        <!-- Units -->
                        <tr>
                            <th v-for="(col, index) in cols" :key="index" :class="col.type">
                                <enac-atpl-dashboard-skills-progress-item v-if="col.type == 'unit'"
                                    :id="col.data.id" :item="col.data" :states="states" :bus="bus">
                                </enac-atpl-dashboard-skills-progress-item>
                                <div class="p-1" v-if="col.type == 'delimiter-left'"></div>
                                <div class="p-1" v-if="col.type == 'delimiter-right'"></div>
                            </th>
                        </tr>
                        <!-- Grade -->
                        <tr>
                            <td v-for="(col, index) in cols" :key="index" :class="col.type"
                                v-html="gradeRendering(col)"
                            >
                            </td>
                        </tr>
                        <!-- selected indicator -->
                        <tr>
                            <td v-for="(col, index) in cols" :key="index" :class="col.type"
                                v-html="indicatorRendering(col)"
                            >
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-show="loaded" class="skills-progress-competencies float-left">
                <table>
                    <tbody>
                        <!-- Competencies -->
                        <tr v-for="competency in competency_domains_select" :key="competency.value">
                            <td>
                                <button class="btn btn-sm btn-info w-100" disabled
                                    v-if="competency_tag == competency.value"
                                >
                                    {{ competency_domains_tags[competency.value] }}
                                </button>
                                <a :href="competencyLink(competency.value)" class="btn btn-sm btn-white w-100"
                                    v-else
                                >
                                    {{ competency_domains_tags[competency.value] }}
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-show="loaded" class="skills-progress-indicators">
                <table class="w-100">
                    <tbody>
                        <!-- Competencies -->
                        <tr v-for="(indicator, index) in indicators" :key="index">
                            <td>
                                <h4 class="font-weight-bold mb-1">{{ indicator.parent }}</h4>
                                <p class="mb-0">{{ indicator.name }}</p>
                            </td>
                            <td class="text-right">
                                <button :class="showButtonClass(indicator)" @click="selectedIndicator = indicator.uuid">Show</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </trax-ui-card-icon-header>
    </div>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'enac-atpl-dashboard-skills-progress'}
        },
    
        data: function() {
            return {
                lang: lang,
                app_url: app_url,
                registration: data.registration,
                phase: data.phase,
                learner: data.learner,
                competency_tag: data.competency_tag,
                competency_domains_select: data.competency_domains_select,
                competency_domains_tags: data.competency_domains_tags,
                unitsLoaded: false,
                statesLoaded: false,
                endpoint: app_url+'polaris/api/front/sections',
                endpointParams: {
                    options: {
                        registration: data.registration.id,
                        user: data.learner.id
                    },
                    filters: {
                        phase_id: data.phase.id
                    },
                    sort: ['order']
                },
                endpoint_states: app_url+'polaris/api/front/dashboard/registrations/'+data.registration.id+'/phases/'+data.phase.id+'/learners/'+data.learner.id+'/with-competencies/'+data.competency_tag,
                sections: [],
                states : {},
                titles: [],
                cols: [],
                indicators: [],
                indicatorsTitles: {},
                flightPhases: {},
                selectedIndicator: null,
                timeMode: true,
                bus: new Vue()
            }
        },

        created: function() {
            this.getData();
            this.getStates();

            this.bus.$on('switch-mode', this.switchMode);
        },

        computed: {

            loaded() {
                return this.unitsLoaded && this.statesLoaded
            },

            actions() {
                return [
                    {
                        name: this.timeMode ? 'Switch to modules view' : 'Switch to time view',
                        color: 'default',
                        event: 'switch-mode' 
                    }
                ]
            }
        },

        watch: {

            loaded() {
                this.initCols()
                this.initIndicators()
            }
        },
        
        methods: {

            switchMode() {
                this.timeMode = !this.timeMode
                this.initCols()
            },

            competencyLink(code) {
                return this.app_url + 'polaris/ui/atpl-dashboard/registration/' + this.registration.id + '/enac-atpl-phase/' + this.phase.id + '/learner/' + this.learner.id + '/skills-progress/' + code
            },

            programUnit(learning_unit) {
                return !learning_unit.registration_id;
            },

            groupUnit(learning_unit) {
                return learning_unit.registration_id && !learning_unit.user_id;
            },

            userUnit(learning_unit) {
                return learning_unit.user_id;
            },

            unitWithCompetencies(learning_unit) {
                return learning_unit.type == 'enac-atpl-simu-session'
                    || learning_unit.type == 'enac-atpl-flight-session'
                    || learning_unit.type == 'enac-atpl-level-report'
                    ;
            },

            getData() {
                var that = this;
                axios.get(that.endpoint, {params: that.endpointParams})
                    .then(function (response) {
                        that.sections = response.data.data;
                        that.unitsLoaded = true;
                    })
                    .catch(function (error) {
                    });
            },

            getStates() {
                var that = this;
                axios.get(this.endpoint_states)
                    .then(function (response) {
                        that.states = Array.isArray(response.data.data) ? {} : response.data.data;
                        that.indicatorsTitles = Array.isArray(response.data.included.indicators) ? {} : response.data.included.indicators
                        that.flightPhases = Array.isArray(response.data.included.flight_phases_names) ? {} : response.data.included.flight_phases_names
                        that.statesLoaded = true;
                    })
                    .catch(function (error) {
                    });
            },

            initCols() {
                if (this.timeMode) {
                    this.initColsByTime()
                } else {
                    this.initColsByModules()
                }
            },

            initColsByTime() {
                this.titles = []
                this.cols = []
                
                // Merge all the units.
                var units = []
                for (var index in this.sections) {
                    var section = this.sections[index]
                    var programUnits = section.learning_units.filter(unit => this.programUnit(unit) && this.unitWithCompetencies(unit))
                    var groupUnits = section.learning_units.filter(unit => this.groupUnit(unit) && this.unitWithCompetencies(unit))
                    var userUnits = section.learning_units.filter(unit => this.userUnit(unit) && this.unitWithCompetencies(unit))

                    units = [...units, ...programUnits, ...groupUnits, ...userUnits]
                }
                
                // Sort them.
                var sorted = units.sort((a, b) => {
                    var stateA = this.states[a.id]
                    var stateB = this.states[b.id]
                    if (!stateA && !stateB) {
                        return 0
                    }
                    if (!stateA && stateB) {
                        return 1
                    }
                    if (stateA && !stateB) {
                        return -1
                    }
                    if (!stateA.date) {
                        return 1
                    }
                    if (!stateB.date) {
                        return -1
                    }
                    if (stateA.date == stateB.date) {
                        return 0
                    }
                    return stateA.date > stateB.date ? 1 : -1
                })

                // Add them to the cols
                for (var index in sorted) {
                    var unit = sorted[index]
                    this.cols.push({
                        type: 'unit',
                        data: unit,
                    })
                }
            },

            initColsByModules() {
                this.titles = []
                this.cols = []
                
                for (var index in this.sections) {
                    var section = this.sections[index]
                    var programUnits = section.learning_units.filter(unit => this.programUnit(unit) && this.unitWithCompetencies(unit))
                    var groupUnits = section.learning_units.filter(unit => this.groupUnit(unit) && this.unitWithCompetencies(unit))
                    var userUnits = section.learning_units.filter(unit => this.userUnit(unit) && this.unitWithCompetencies(unit))
                    var length = programUnits.length + groupUnits.length + userUnits.length

                    if (length == 0) {
                        continue
                    }

                    // Titles.
                    this.titles.push({
                        colspan: length,
                        title: section.name,
                        type: 'module',
                    })
                    this.titles.push({
                        colspan: 1,
                        title: '',
                        type: 'delimiter-left',
                    })
                    this.titles.push({
                        colspan: 1,
                        title: '',
                        type: 'delimiter-right',
                    })

                    // First the program units.
                    for (var index2 in programUnits) {
                        var unit = programUnits[index2]
                        this.cols.push({
                            type: 'unit',
                            data: unit,
                        })
                    }
                   // Then the group units.
                   if (groupUnits.length > 0) {
                        for (var index2 in groupUnits) {
                            var unit = groupUnits[index2]
                            this.cols.push({
                                type: 'unit',
                                data: unit,
                            })
                        }
                   }

                    // Finally the user units.
                    if (userUnits.length > 0) {
                        for (var index2 in userUnits) {
                            var unit = userUnits[index2]
                            this.cols.push({
                                type: 'unit',
                                data: unit,
                            })
                        }
                    }

                    // Section delimiter.
                    this.cols.push({
                        type: 'delimiter-left',
                        data: section
                    })
                    this.cols.push({
                        type: 'delimiter-right',
                        data: section
                    })
                }
            },

            gradeRendering(col) {
                if (col.type != 'unit') {
                    return ''
                }
                var state = this.states[col.data.id]
                if (!state) {
                    return ''
                }
                if (state.grade) {
                    return this.gradeHtml(state.grade, state.color_status)
                }
                if (state.passed === undefined) {
                    return ''
                }
                if (col.data.type == 'enac-atpl-level-report') {
                    return this.gradeHtml(state.passed ? 'S' : 'U', state.color_status)
                }
                return this.gradeHtml(state.passed ? 'P' : 'F', state.color_status)
            },

            gradeHtml(content, color) {
                return '<div class="font-weight-bold text-center text-' + color + '">' + content + '</div>'
            },

            showButtonClass(indicator) {
                return this.selectedIndicator == indicator.uuid
                    ? 'btn btn-sm btn-info'
                    : 'btn btn-sm btn-white'
            },

            indicatorRendering(col) {
                if (col.type != 'unit' || !this.selectedIndicator) {
                    return ''
                }
                var color = 'white'
                var indicator = this.indicators.find(indic => indic.uuid == this.selectedIndicator)

                if (indicator.passed.indexOf(col.data.id) >= 0) {
                    color = 'success'
                }
                if (indicator.failed.indexOf(col.data.id) >= 0) {
                    color = 'danger'
                }
                return '<div class="pb-2 bg-' + color + '"></div>'
            },

            initIndicators() {
                var indicatorsObject = {}
                for (var index in this.states) {
                    var state = this.states[index]
                    if (!state.competencies || !state.competencies[this.competency_tag] || !state.competencies[this.competency_tag].indicators) {
                        continue
                    }
                    for (var uuid in state.competencies[this.competency_tag].indicators) {
                        if (!indicatorsObject[uuid]) {
                            var type = this.indicatorsTitles[uuid].type
                            var parent = this.flightPhases[type] ? this.flightPhases[type] : this.lang.polaris.training.competencies
                            indicatorsObject[uuid] = {
                                uuid: uuid,
                                name: this.indicatorsTitles[uuid].name,
                                parent: parent,
                                passed: [],
                                failed: [],
                            }
                        }
                        if (state.competencies[this.competency_tag].indicators[uuid] == 3) {
                            indicatorsObject[uuid].passed.push(parseInt(index))
                        } else {
                            indicatorsObject[uuid].failed.push(parseInt(index))
                        }
                    }
                }
                this.indicators = Object.values(indicatorsObject).sort((a, b) => {
                    if (a.passed.length + a.failed.length == b.passed.length + b.failed.length) {
                        return 0
                    }
                    return a.passed.length + a.failed.length > b.passed.length + b.failed.length
                        ? -1 : 1
                })
            }
        }
    }
</script>

<style scoped>

    .skills-progress-units {
        overflow-x: auto;
    }
    .skills-progress-units table {
        margin-left: 70px;
        margin-bottom: 10px;
    }
    .skills-progress-units table td {
        padding: 0;
    }
    .skills-progress-units table th.delimiter-left,
    .skills-progress-units table td.delimiter-left {
        border-right: 3px #aaa solid;
    }
    .skills-progress-indicators {
        padding-left: 110px;
    }
    .skills-progress-indicators h4 {
        font-size: 16px;
    }
    .skills-progress-indicators tr {
        border-bottom: solid 1px #ccc;
    }
    .skills-progress-indicators tr:last-child {
        border-bottom: solid 0px #ccc;
    }
    .skills-progress-indicators td {
        padding: 12px 0 12px 0;
    }
    .skills-progress-indicators tr:first-child td {
        padding-top: 0;
    }
</style>